import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["source"]

  copy(event) {
    event.preventDefault()

    let text = this.textValue

    // If no text value, try to get from source target
    if (!text && this.hasSourceTarget) {
      text = this.sourceTarget.value || this.sourceTarget.textContent
    }

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback(event.currentTarget)
    })
  }

  showFeedback(button) {
    const originalText = button.getAttribute('data-original-text') || button.innerHTML
    button.setAttribute('data-original-text', originalText)

    // Show checkmark briefly
    const originalInner = button.innerHTML
    button.innerHTML = `
      <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
      </svg>
    `

    setTimeout(() => {
      button.innerHTML = originalInner
    }, 1500)
  }
}
